import React from 'react';
import { Card, CardContent } from '@/components/ui';

export interface MaterialItem {
  id: string;
  name: string;
  used: string;
  remaining: string;
}

interface MaterialUsageProps {
  items?: MaterialItem[];
  isLoading?: boolean;
}

export function MaterialUsage({ items, isLoading }: MaterialUsageProps) {
  const defaultItems: MaterialItem[] = [
    { id: '1', name: 'Đất trồng', used: '2.5 m³', remaining: '17.5 m³' },
    { id: '2', name: 'Phân hữu cơ', used: '50 kg', remaining: '150 kg' },
    { id: '3', name: 'Cây bụi', used: '35 cây', remaining: '65 cây' },
    { id: '4', name: 'Cỏ nhung', used: '120 m²', remaining: '380 m²' },
    { id: '5', name: 'Ống LDPE 20mm', used: '80 m', remaining: '120 m' },
  ];

  const displayItems = items || defaultItems;

  return (
    <Card className="border-none shadow-sm h-full">
      <CardContent className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-sm font-bold text-slate-800">Vật tư sử dụng hôm nay</h3>
          <button className="text-[10px] font-bold text-emerald-600 hover:underline">Xem chi tiết</button>
        </div>

        <div className="w-full">
          <div className="grid grid-cols-3 pb-3 border-b border-slate-50 text-[10px] font-bold text-slate-400 uppercase tracking-tight">
            <span>Vật tư</span>
            <span className="text-right">Đã dùng</span>
            <span className="text-right">Còn lại</span>
          </div>
          <div className="divide-y divide-slate-50">
            {displayItems.map((item) => (
              <div key={item.id} className="grid grid-cols-3 py-3 text-xs">
                <span className="font-bold text-slate-700">{item.name}</span>
                <span className="text-right font-medium text-slate-600">{item.used}</span>
                <span className="text-right font-medium text-slate-400">{item.remaining}</span>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
